// extracted by mini-css-extract-plugin
export default {"cover":"styles_cover__xIsJP","cover__img":"styles_cover__img__5s2Np","text":"styles_text__srYE1"};